import { AssignmentModel } from "@bryntum/schedulerpro";

export class Assignment extends AssignmentModel {
  static get $name() {
    return "Assignment";
  }

  static get fields() {
    return [
      { name: "resourceId", persist: false },
      // adding optional chain r?.id as assigning event to an archived resource cause it to break for the other user if their show archived is set to false
      { name: "resource", persist: true, serialize : r => r?.id },
      { name: "eventId", persist: false },
      { name: "event", persist: true, serialize : r => r?.id },
    ];
  }
}

Assignment.exposeProperties();
